import { render } from "./SystInfView.vue?vue&type=template&id=723be031&scoped=true"
import script from "./SystInfView.vue?vue&type=script&lang=js"
export * from "./SystInfView.vue?vue&type=script&lang=js"

import "./SystInfView.vue?vue&type=style&index=0&id=723be031&scoped=true&lang=css"

import exportComponent from "C:\\AT\\Sites\\agiles_website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-723be031"]])

export default __exports__